<template lang="pug">
ubett(v-if="brand === 'BT'")
wbetnew(v-else-if="['WBET','FOTBET'].includes(brand)")
wbet(v-else)
</template>

<script>
import config from '@/config';

export default {
  name: 'Home',
  components: {
    wbet: () => import('@/views/m/_wbet'),
    // wbetnew: () => import('@/views/m/_wbetnew'),
    wbetnew: () => import('@/views/m/_wbetnew'),
    ubett: () => import('@/views/m/_ubett')
  },
  computed: {
    brand() {
      return config.brand;
    }
  }
};
</script>
